import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_barcode.svg'


const _hoisted_1 = { class: "flex items-center gap-x-2" }
const _hoisted_2 = { class: "w-1/4 items-center relative mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "absolute right-3 top-3.5 bottom-4",
  src: _imports_0,
  alt: "barcode"
}
const _hoisted_4 = { class: "flex items-center gap-2 w-1/4" }
const _hoisted_5 = { class: "w-1/4" }
const _hoisted_6 = { class: "w-1/4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Search, {
        id: "filter-search",
        onInput: _ctx.onSearch,
        onClear: _ctx.clearSearch,
        value: _ctx.filter.search,
        class: "w-full rounded-md",
        placeholder: _ctx.$t('dashboard.hanging.searchOrScan'),
        isIconLeft: "",
        isIconClearRight: ""
      }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
      (!_ctx.filter.search)
        ? (_openBlock(), _createBlock("img", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterDay, (row, index) => {
        return (_openBlock(), _createBlock("button", {
          key: index,
          onClick: ($event: any) => (_ctx.toggleActive(row.value)),
          class: ["rounded-md leading-tight px-2 align-middle font-semibold text-xs border h-10 w-full", _ctx.activeIndexes.includes(row.value) ? 'text-red-lp-100 font-semibold border-b-2 border-red-lp-100' : 'text-gray-lp-600 bg-white']
        }, _toDisplayString(row.name), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CustomDropdown, {
        isExpand: _ctx.statusSelect,
        "onUpdate:isExpand": _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusSelect = $event)),
        options: _ctx.statusData,
        onSelect: _ctx.onSelectStatus,
        placeholder: _ctx.$t('dashboard.hanging.statusPackageExistence'),
        class: "w-full",
        isCustomWidth: "",
        selectedItem: _ctx.filter.existenceStatus
      }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_CustomDropdown, {
        isExpand: _ctx.statusSelectFollow,
        "onUpdate:isExpand": _cache[2] || (_cache[2] = ($event: any) => (_ctx.statusSelectFollow = $event)),
        options: _ctx.statusFollowUp,
        onSelect: _ctx.onSelectStatusFollow,
        placeholder: _ctx.isHangingIncoming ? _ctx.$t('dashboard.hanging.activityStatus') : _ctx.$t('dashboard.hanging.followUpStatus'),
        class: "w-full",
        isCustomWidth: "",
        selectedItem: _ctx.filter.statusFollowUp
      }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
    ])
  ]))
}